export default "__VITE_ASSET__BsJq_OBG__"